/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Spec_PriceInputs */

const en_endpoint_spec_price = /** @type {(inputs: Endpoint_Spec_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const zh_hans1_endpoint_spec_price = /** @type {(inputs: Endpoint_Spec_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

const pt_br2_endpoint_spec_price = /** @type {(inputs: Endpoint_Spec_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço`)
};

const es_endpoint_spec_price = /** @type {(inputs: Endpoint_Spec_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const fr_endpoint_spec_price = /** @type {(inputs: Endpoint_Spec_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

const de_endpoint_spec_price = /** @type {(inputs: Endpoint_Spec_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const ru_endpoint_spec_price = /** @type {(inputs: Endpoint_Spec_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const it_endpoint_spec_price = /** @type {(inputs: Endpoint_Spec_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Endpoint_Spec_PriceInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_spec_price = /** @type {((inputs?: Endpoint_Spec_PriceInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Spec_PriceInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_spec_price(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_spec_price(inputs)
	if (locale === "es") return es_endpoint_spec_price(inputs)
	if (locale === "fr") return fr_endpoint_spec_price(inputs)
	if (locale === "de") return de_endpoint_spec_price(inputs)
	if (locale === "ru") return ru_endpoint_spec_price(inputs)
	if (locale === "it") return it_endpoint_spec_price(inputs)
	return en_endpoint_spec_price(inputs)
});